/**
 * @generated SignedSource<<cc2d4be6691cfee1ebee1b666bcac122>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type RoundListAdditionalBookingInfo_Booking$data = {
  readonly __typename: string;
  readonly durationMins?: number | null | undefined;
  readonly id: string;
  readonly lessonType?: {
    readonly id: string;
  } | null | undefined;
  readonly rounds: {
    readonly count: number;
  } | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly type: FacilityType;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PunchPassSummary_Booking" | "RoundListAdditionalBookingInfoItemDisplay_Booking" | "RoundListAdditionalLessonInfoItemDisplay_Booking" | "useGetBookingCharge_Booking" | "useGetBookingFees_Booking" | "useGetSummaryCalculations_Booking">;
  readonly " $fragmentType": "RoundListAdditionalBookingInfo_Booking";
};
export type RoundListAdditionalBookingInfo_Booking$key = {
  readonly " $data"?: RoundListAdditionalBookingInfo_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoundListAdditionalBookingInfo_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoundListAdditionalBookingInfo_Booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonType",
          "kind": "LinkedField",
          "name": "lessonType",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoundListAdditionalBookingInfoItemDisplay_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingFees_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingCharge_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoundListAdditionalLessonInfoItemDisplay_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetSummaryCalculations_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PunchPassSummary_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "725feba188024713f842b639131e4c9a";

export default node;
